import { definitions } from 'api/generated/photo'
import { Gender } from 'common-constants/api6.types'
import { GQLGender } from 'generated-graphql/graphql'

/**
 * Ручное добавление фото, которые в рейтинге и остальных фото.
 * Фото в рейтинге и фото в профиле могут отличается.
 * В рейтинге, ставим сначала фото из рейтинга и все остальные
 * В профиле достаем из запроса omniAlbumPhoto
 */
export const ADD_PHOTOS_PHOTO_VIEWER_RATING_ACTION =
  'ADD_PHOTOS_PHOTO_VIEWER_RATING_ACTION' as const

export const addPhotosPhotoViewerRatingAction = (
  photos: definitions['OmniAlbumPhoto'][],
  name: string,
  gender: GQLGender | Gender | null
) => ({
  type: ADD_PHOTOS_PHOTO_VIEWER_RATING_ACTION,
  photos,
  name,
  gender,
})
